// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nf-0";
export var discountCodeInput = "_nf-1";